<template>
    <div class="w100_ h100_ backfff" v-loading="loading">
        <div v-if="isShow" class="w100_ h100_ ">
            <iframe ref="iframeModel" :src="url" style="width: 100%; height: 100%" frameborder="0">
            </iframe>
        </div>
    </div>
</template>
<script lang="js">
import { getReportToken } from "@/api/statement"; // 报表统计请求
export default {
    data() {
        return {
            userCode:null,
            url:"https://college.scxinglin.com/xl/ReportServer/v10/entry/access/217360c1-2774-49ce-ab43-bc1be31416e1?preview=true",
            isShow:false,
            loading:false,
        }
    },
    created(){
      this.userCode= this.$session.get('user').userCode
      if(this.userCode){
        this.getData()
      }
    },
    methods: {
     async getData() {
        this.loading=true
            let obj = {
                user_name: this.userCode
            };
            const res=await getReportToken(obj)
            if (res.errorCode === "0000") {
                    this.url += `&${res.data.paramName}=${encodeURIComponent(
                        res.data.paramValue
                    )}`;
                    this.isShow = true;
                    this.loading=false;
                }
        }
    }
}
</script>